import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import {IFlag} from "@models/shared/IFlag.ts";
import {IGetFlagsFilter} from "@localization/siteMap/endpoints/flags/filters/IGetFlagsFilter.ts";
import {__flags_endpoints} from "@components/flags/endpoints/__flags_endpoints.ts";

interface FlagsPesquisaProps extends DefaultConsumerPesquisaAutoProps<IFlag, IGetFlagsFilter> {
}

export function FlagsPesquisa(props: FlagsPesquisaProps) {
    const handleItemSelected = (item: IFlag | undefined) => {
        if (props.onItemSelected) {
            props.onItemSelected(item);
        }
    };

    const handleFormat = (flag: IFlag) => `${flag.id} - ${flag.nome} `;

    return (
        <DefaultPesquisaAuto<IFlag, IGetFlagsFilter>
            endpoint={__flags_endpoints.GetFlags} // Pass the API function
            searchField={'nome'}
            itemToString={handleFormat}   // Pass the formatting function
            onItemSelected={handleItemSelected} // Pass the selection handler
            display={{
                name: "Flag"
            }}
            {...props}
        />
    );
}